module.exports = __webpack_public_path__ + "static/assets/da32ebed94fe90839085d2b782a8a1f8.gif";